import React, { useState, useEffect } from "react";
import styles from "../../Home.module.scss";
import { useDataStore } from "store/DataStoreContext";
import { Skeleton } from "antd";
import TitleAndBreadCrumb from "components/TitleAndBreadCrumb/TitleAndBreadCrumb";
import { TranslateLanguage } from "util/Translate";
import { actionType } from "store/dataReducer";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import PretestCard from "./PretestCard";

const translate = new TranslateLanguage();

const HomePretest = ({ onCLickLoadMore }) => {
  const {
    state: { educationType, pretest },
    dispatch,
    fetchPretest,
  } = useDataStore();
  const history = useHistory();

  const handleClickCard = (id) => {
    const pretestData = _.find(pretest.data, (obj) => obj.id === id);
    history.push(`/pretest/${id}`, { pretestData: pretestData });
  };

  useEffect(() => {
    let timeoutId;

    if (educationType.activeLevel) {
      timeoutId = setTimeout(() => {
        fetchPretest();
      }, 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [educationType.activeLevel]);

  return (
    <div className={styles.home_bundle} style={{ marginTop: "1.5rem" }}>
      {!_.isEmpty(pretest.data) && (
        <div className={styles.home_bundle_container}>
          <div className={styles.divSuggestTitle}>
            {!pretest.loading ? (
              <TitleAndBreadCrumb
                title={{ text: translate.convert("Pretest") }}
                option={{
                  options: {
                    more: {
                      text: translate.convert("ดูทั้งหมด"),
                      onClick: () => onCLickLoadMore(),
                    },
                  },
                }}
              />
            ) : (
              <div
                className={styles.divSuggestTitleSkeleton}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "1.5rem",
                }}
              >
                <Skeleton.Input active={true} />
                <Skeleton.Input active={true} />
              </div>
            )}
          </div>

          <div className={styles.divCardBundle}>
            {pretest.loading ? (
              <>Loading</>
            ) : (
              <PretestCard handleClickCard={handleClickCard} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePretest;
